import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../../../js/Controller';
import { BaseQuote } from './../../../../../common/js/quote/BaseQuote';
import { CoverpathTermQuote } from '../../../../../coverpath-common/classes/quote/coverpath/CoverpathTermQuote';
import { CoverpathCustomer } from '../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathCustomer';
import { BaseQuickQuoteService } from '../../../../../coverpath-common/angular/services/quote/base-quick-quote.service';
import { CoverpathWholeLifeQuote } from '../../../../../coverpath-common/classes/quote/coverpath/CoverpathWholeLifeQuote';
import { AuthenticationService } from '../../../../../coverpath-common/angular/services/authentication/authentication.service';
import type { QuoteForm } from '../../../../../coverpath-agent/public/js/components/home-new/quote-or-apply-new/QuoteForm';

@Injectable()
export class QuickQuoteService extends BaseQuickQuoteService {
  controller: Controller;

  constructor(
    protected authenticationService: AuthenticationService,
    private amorphicService: AmorphicService,
    protected router: Router
  ) {
    super(authenticationService, router);
    this.controller = amorphicService.controller as Controller;
  }

  public hasAssociatedAgent(): boolean {
    return (
      !!this.controller.customer.application &&
      !!this.controller.customer.application.primaryPolicy &&
      !!this.controller.customer.application.primaryPolicy.servicingAgent
    );
  }

  public getCurrentQuote(): BaseQuote {
    return this.controller.customer.clientQuote || this.controller.customer.primaryQuote;
  }

  public getPrimaryQuote(): BaseQuote {
    return this.controller.customer.primaryQuote;
  }

  /**
   * Get the current agent quote
   *
   * @returns the first insurance quote that isn't a client quote
   */
  public getCurrentAgentQuote(): BaseQuote {
    return this.controller.customer.insuranceQuotes.find((quote) => quote.isAdvisorQuote);
  }

  public setCustomerQuote(): void {
    const quote: CoverpathTermQuote | CoverpathWholeLifeQuote =
      this.controller.customer.wholeLifeQuote || (this.controller.customer.clientQuote as CoverpathTermQuote);
    const customer: CoverpathCustomer = this.controller.customer;

    customer.advanceApplicationProgress(1);
  }

  public setQuickQuoteForm(quoteForm: QuoteForm) {
    this.controller.setQuickQuoteForm(quoteForm);
  }

  public clearQuickQuoteForm() {
    this.controller.clearQuickQuoteForm();
  }

  /**
   * creates and sets a customer-modifiable term quote from the agent created term quote
   */
  public setNewCoverpathClientQuote(): void {
    const newQuote: CoverpathTermQuote = this.controller.createClientQuote();
    newQuote.copyFromCoverpathTermQuote(this.controller.customer.termQuote);
    this.controller.customer.insuranceQuotes.unshift(newQuote);
  }

  public isCoverpathTermQuote(quote: BaseQuote): boolean {
    return this.controller.isCoverpathTermQuote(quote);
  }
}
